import React from "react";
import { HISTORY } from "../lib/data";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from "../components/ui/dialog";

export default function Historial() {
  return (
    <section id="historial" data-testid="historial-section" className="bg-[hsl(var(--hh-bone))] py-20 md:py-28 lg:py-32">
      <div className="container-hh">
        <div className="flex items-end justify-between flex-wrap gap-6 reveal">
          <div className="max-w-xl">
            <div className="flex items-center gap-3 sm:gap-4 mb-5 sm:mb-6">
              <span className="accent-line" />
              <span className="overline text-[hsl(var(--hh-moss))]" style={{ fontSize: "0.65rem" }}>
                Historial de proyectos
              </span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-balance">
              Nuestra experiencia es la{" "}
              <em style={{ fontStyle: "italic", color: "hsl(var(--hh-moss))" }}>
                mejor carta de presentación.
              </em>
            </h2>
          </div>
          <p className="max-w-md text-[hsl(0,0%,32%)] text-sm sm:text-base md:text-lg leading-relaxed">
            Más de veinte conjuntos y edificios entregados y vendidos desde 2002.
            Toca cualquier proyecto para verlo en grande.
          </p>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {HISTORY.map((p, i) => (
            <Dialog key={i}>
              <DialogTrigger asChild>
                <button
                  data-testid={`historial-item-${i}`}
                  className="group block text-left"
                >
                  <div className="relative aspect-[4/5] overflow-hidden bg-black">
                    <img
                      src={p.image}
                      alt={`${p.name} — ${p.year}`}
                      className="absolute inset-0 h-full w-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-[900ms]"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
                    <div className="absolute bottom-0 inset-x-0 p-3 md:p-4 text-white">
                      <div className="overline text-[hsl(var(--hh-sunrise))]" style={{ fontSize: "0.55rem" }}>
                        {p.year}
                      </div>
                      <div className="font-display text-sm md:text-base mt-1 leading-tight">
                        {p.name}
                      </div>
                      <div className="overline mt-1 text-white/50" style={{ fontSize: "0.5rem" }}>
                        Vendido
                      </div>
                    </div>
                  </div>
                </button>
              </DialogTrigger>
              <DialogContent className="max-w-3xl p-0 bg-black border-white/10 overflow-hidden">
                <DialogTitle className="sr-only">{p.name}</DialogTitle>
                <DialogDescription className="sr-only">{p.name} — proyecto entregado en {p.year} por House &amp; Home.</DialogDescription>
                <div className="relative">
                  <img src={p.image} alt={p.name} className="w-full h-auto max-h-[80vh] object-contain bg-black" />
                  <div className="p-5 bg-black text-white">
                    <div className="overline text-[hsl(var(--hh-sunrise))]" style={{ fontSize: "0.6rem" }}>{p.year}</div>
                    <div className="font-display text-2xl md:text-3xl mt-1">{p.name}</div>
                    <div className="overline text-white/50 mt-2" style={{ fontSize: "0.55rem" }}>Entregado · Vendido</div>
                  </div>
                </div>
              </DialogContent>
            </Dialog>
          ))}
        </div>
      </div>
    </section>
  );
}
